module.exports = __webpack_public_path__ + "img/twitter.e09c171e.svg";